import React from 'react';

import {
  Button,
  Box,
  Typography,
  Modal,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import UnsubscribeIcon from '../../../../common/assets/icons/unsubscribe_icon.svg';
import { FlorencePAGES } from '../../../../common/components/tfa-auth/constants/pages';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
};

const SubscriptionRequiredModal: React.FC<Props> = ({
  open,
  loading = false,
  onClose,
}) => {
  const navigate = useNavigate();

  const redirectToSubscriptionScreen = () => {
    navigate(FlorencePAGES.subscriptions);
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {loading && (
          <CircularProgress
            color='primary'
            size='64px'
            style={{ display: 'block', margin: '24px auto' }}
          />
        )}
        {!loading && (
          <div>
            <img src={UnsubscribeIcon} alt='Unsubscribe' />
            <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
              No Active Subscription
            </Typography>
            <Typography fontSize={16} sx={{ mt: 2, mb: 2 }}>
              You need to have an active subscription before being able to buy a
              scan package
            </Typography>
            <Button
              onClick={onClose}
              variant='contained'
              color='primary'
              disableElevation
              sx={{
                width: '100%',
                height: 48,
                marginTop: '20px',
                borderRadius: '15px',
              }}
            >
              <Typography color='white'>Ok, Got it!</Typography>
            </Button>
            <Button
              onClick={() => redirectToSubscriptionScreen()}
              variant='contained'
              color='secondary'
              disableElevation
              sx={{
                width: '100%',
                height: 48,
                marginTop: '10px',
                borderRadius: '15px',
              }}
            >
              <Typography color='white'>Redirect me</Typography>
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default SubscriptionRequiredModal;
